// extracted by mini-css-extract-plugin
export default {"services":"_healthAndScreening_services__9q9dG","headphonesIcon":"_healthAndScreening_headphonesIcon__MyLxB"};